export const CHANGE_INTERVENTION_STEP = 'STEPS/INTERVENTION/PATCH';
export const CHANGE_INTERVENTION_STEP_SUCCESS = 'STEPS/INTERVENTION/PATCH_SUCCESS';
export const CHANGE_INTERVENTION_STEP_FAILURE = 'STEPS/INTERVENTION/PATCH_FAILURE';

export const FETCH_STEPS_SUCCESS = 'STEPS/FETCH/SUCCESS';
export const FETCH_STEPS_FAILURE = 'STEPS/FETCH/FAILURE';

export const SET_STEPS_DETAILS_READY = 'STEPS/DETAILS/READY';

export const OPEN_FOLLOW_UP_CONFIG_MODAL = 'STEPS/FOLLOW_UP_CONFIG/MODAL/OPEN';
export const CLOSE_FOLLOW_UP_CONFIG_MODAL = 'STEPS/FOLLOW_UP_CONFIG/MODAL/CLOSE';

export const SAVE_FOLLOW_UP_CONFIG = 'STEPS/FOLLOW_UP_CONFIG/PUT/REQUEST';
export const SAVE_FOLLOW_UP_CONFIG_SUCCESS = 'STEPS/FOLLOW_UP_CONFIG/PUT/SUCCESS';
export const SAVE_FOLLOW_UP_CONFIG_FAILURE = 'STEPS/FOLLOW_UP_CONFIG/PUT/FAILURE';

export const PATCH_STEPS_MODE_REQUEST = 'STEPS/MODE/PATCH_REQUEST';
export const PATCH_STEPS_MODE_SUCCESS = 'STEPS/MODE/PATCH_SUCCESS';
export const PATCH_STEPS_MODE_FAILURE = 'STEPS/MODE/PATCH_FAILURE';

export const REORDER_STEPS_REQUEST = 'STEPS/REORDER/PUT_REQUEST';
export const REORDER_STEPS_SUCCESS = 'STEPS/REORDER/PUT_SUCCESS';
export const REORDER_STEPS_FAILURE = 'STEPS/REORDER/PUT_FAILURE';

export const CREATE_STEP_REQUEST = 'STEP/POST_REQUEST';
export const CREATE_STEP_SUCCESS = 'STEP/POST_SUCCESS';
export const CREATE_STEP_FAILURE = 'STEP/POST_FAILURE';

export const UPDATE_STEP_REQUEST = 'STEP/PUT_REQUEST';
export const UPDATE_STEP_SUCCESS = 'STEP/PUT_SUCCESS';
export const UPDATE_STEP_FAILURE = 'STEP/PUT_FAILURE';

export const DELETE_STEP_REQUEST = 'STEP/DELETE_REQUEST';
export const DELETE_STEP_SUCCESS = 'STEP/DELETE_SUCCESS';
export const DELETE_STEP_FAILURE = 'STEP/DELETE_FAILURE';
